/**
 * Utilidades para alertas de fechas en guías de almacén.
 */

export function hasDateWarnings(doc) {
  return Array.isArray(doc?.date_warnings) && doc.date_warnings.length > 0;
}

export function getPrimaryDateWarning(warnings) {
  if (!Array.isArray(warnings) || warnings.length === 0) {
    return null;
  }

  return warnings.find((warning) => warning.severity === 'error') || warnings[0];
}

export function formatDateWarningsTooltip(warnings) {
  if (!Array.isArray(warnings) || warnings.length === 0) {
    return '';
  }

  return warnings.map((warning) => warning.label).join('\n');
}
